<script>
import DataLayer from '@services/data-layer/index'
import MixGridBlock from '@components/mix-grid-block'

export default {
    components: { MixGridBlock },
    data() {
        return {
            mixes: [],
        }
    },
    mounted() {
        DataLayer.mixes.getTrending(6).then(mixes => {
            this.mixes = mixes.body
        })
    },
}
</script>

<template>
    <div v-if="mixes && mixes.length" >
        <BaseSection
            :show-all-link="{ name: 'browse/mixes/trending' }"
            title="Trending"
            reserve-subtitle
            show-all-title="Browse More"
        >
            <MixGridBlock :mixes="mixes"/>
        </BaseSection>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';
</style>
